import React, { ReactNode, FC } from 'react';
import styles from './excerpt.module.scss';

type Props = {
  classNames?: string;
  children: ReactNode;
};

export const ExcerptContainer = React.forwardRef(
  (props: Props, ref?: React.Ref<HTMLDivElement>) => (
    <div className={`${styles.container} ${props.classNames}`} ref={ref}>
      {props.children}
    </div>
  ),
);

ExcerptContainer.defaultProps = {
  classNames: '',
};

export const ExcerptActionBar: React.FC = ({ children }) => (
  <div className={styles.actionBar}>{children}</div>
);

export const ExcerptCount: React.FC = ({ children }) => (
  <div className={styles.count}>{children}</div>
);
